import {
  FETCH_ALL_CHART_OF_ACCOUNTS,
  REMOVE_CHART_OF_ACCOUNTS_ITEM,
  ADD_CHART_OF_ACCOUNTS_ITEM,
  UPDATE_CHART_OF_ACCOUNTS_ITEM,
} from './../../mutation-types';

export default {

  [FETCH_ALL_CHART_OF_ACCOUNTS](state, chartOfAccounts) {
    state.all = chartOfAccounts;
  },

  [REMOVE_CHART_OF_ACCOUNTS_ITEM](state, id) {
    state.all = state.all.filter(p => p.id !== id);
  },

  [ADD_CHART_OF_ACCOUNTS_ITEM](state, chartOfAccountItem) {
    state.all.push(chartOfAccountItem);
  },

  [UPDATE_CHART_OF_ACCOUNTS_ITEM](state, { chartOfAccountsItem, id }) {
    state.all = state.all.map((p) => {
      if (p.id === id) {
        return Object.assign({}, p, chartOfAccountsItem);
      }

      return p;
    });
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/chartOfAccounts/mutations.js